import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import Reveal from "@/components/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Counter = ({ value, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1400;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);
  return <span ref={ref}>{n}{suffix}</span>;
};

const DEFAULT = [
  { value: 27, suffix: "", label: "Years of heritage" },
  { value: 5, suffix: "", label: "Retail divisions" },
  { value: 17, suffix: "", label: "Outlets in Kerala" },
  { value: 1, suffix: " Cr+", label: "Happy customers" },
];

export const Legacy = () => {
  const [stats, setStats] = useState(DEFAULT);
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/stats`)
      .then((r) => r.json())
      .then((d) => {
        setStats([
          { value: d.years ?? 27, suffix: "", label: "Years of heritage" },
          { value: d.divisions ?? 5, suffix: "", label: "Retail divisions" },
          { value: d.outlets ?? 17, suffix: "", label: "Outlets in Kerala" },
          { value: 1, suffix: " Cr+", label: "Happy customers" },
        ]);
      })
      .catch(() => {});
  }, []);

  return (
    <section className="bg-konattu-cream py-24 md:py-36" data-testid="legacy-section">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="font-display font-extrabold text-konattu-red tracking-tightest leading-[0.8] text-[7rem] md:text-[11rem]">
                1998
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="font-body text-konattu-charcoal/70 text-lg max-w-sm mt-4">
                The year a single home appliance store opened its doors in Thengana, and a promise took root.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 gap-px bg-konattu-charcoal/15">
            {stats.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.08}>
                <div data-testid={`stat-${i}`} className="bg-konattu-cream p-8 md:p-10">
                  <div className="font-display font-extrabold text-5xl md:text-6xl text-konattu-charcoal tracking-tight">
                    <Counter value={s.value} suffix={s.suffix} />
                  </div>
                  <div className="font-mono text-[11px] tracking-[0.25em] text-konattu-charcoal/60 mt-3 uppercase">{s.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Legacy;
